export default "__VITE_ASSET__Dcp1dXgg__"